import React from 'react';
//import { makeStyles } from '@mui/styles';
import { useRecoilValue } from 'recoil';
import RadarChart from '../Shared/RadarChart';
import { openProjectNameAtom } from '../Atoms';

//const useStyles = makeStyles({});

const MobileRadarBox = function MobileRadarBox() {
  //const classes = useStyles();
  const openProjectName = useRecoilValue(openProjectNameAtom);
  return (
    <div style={{ marginTop: '5vh' }}>
      <RadarChart projectName={openProjectName} />
    </div>
  );
};

export default MobileRadarBox;
